<template>
    <div>

      <ComIndex :type="2" :orderType="2"/>

    </div>
</template>

<script>
import ComIndex from '../commonIndex'
export default {
  components: {
    ComIndex
  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  }

}
</script>
<style  scoped>

</style>
